// extracted by mini-css-extract-plugin
export default {"mCard":"TD-z","image":"UD-z","imageNoBackground":"VD-z","imageHasCategory":"WD-z","fullWidth":"XD-z"};